import { Button, Divider, Tab, Tabs } from '@blueprintjs/core';
import { faWalking, faWheelchair } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment-timezone';
import React from 'react';
import { formatValue } from '../../../utils/helpers';
import { SHORT_DATE_TIME_FORMAT_24, SHORT_TIME_FORMAT_24 } from '../../../utils/Constants';
import MapContainer from '../../googleMapsComponents/mapContainer';
import { getDistanceMatrix } from '../../services/googleApiService';
import {
  asOfSpan, buttonMap, fontWeightBold, gurneyIcon, inlineFlex, mapContainerSetting, mapFooterContainer,
  mapHeaderContainer, spanSetting, tabSpanMargin, tripsIcons, willCallContainer
} from '../../styles';
import './styles.css';
import TripDetailTabPanel from './tripDetailTabPanel';
import TripNotesPanel from './tripNotesPanel';
import LoadingSpinner from '../../loadingSpinner.jsx';

const gurney = require('../../../img/stretcher_icon.svg');

export default class TripsDetailsComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedTrip: props.selectedTrip,
      isMapEnable: false,
      openTripContainer: props.openTripContainer ? props.openTripContainer : '',
      height: 0
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    // Remove blueprints default div structure for tabs, with the objective of using % heights
    // var wrapper = document.querySelector('.bp3-tabs');
    // // Replace the whole wrapper with its own contents
    // wrapper.outerHTML = wrapper.innerHTML;
    // var tablist = document.getElementsByClassName('bp3-tab-panel');
    // tablist[0].style.overflow = 'auto';
  }

  calculateTabPanelHeight() {
    return {
      margin: '1em',
      width: '35em',
      marginRight: '2em',
      height: `${this.state.height - 40}px`,
      fontSize: '90%',
      position: 'sticky',
      top: '60px',
      bottom: '10px'
    };
  }

  updateWindowDimensions = () => {
    this.setState({ height: window.innerHeight });
  }

  handleShowMapClick = async () => {
    const trip = this.state.selectedTrip;

    trip.eta = await this.getEta(trip);

    this.setState({
      isMapEnable: true,
    })
  }

  serviceLevelSwitch = (serviceLevelname) => {
    if (serviceLevelname?.includes("AMB")) {
      return (<FontAwesomeIcon icon={faWalking} />);
    } else if (serviceLevelname?.includes("WC")) {
      return (<FontAwesomeIcon icon={faWheelchair} />);
    } else if (serviceLevelname?.includes("GUR")) {
      return (<img alt="gurney-icon" style={gurneyIcon} src={gurney} />);
    } else {
      return (null);
    }
  }

  getDistanceMatrix = async (actualCoordinates, destCoordinates) => {
    try {
      const data = await getDistanceMatrix(actualCoordinates, destCoordinates);
      if (data.rows.length > 0 && data.rows[0].elements[0].status === 'OK') {
        return data.rows[0].elements[0].duration.text;
      } else {
        return 'N/A';
      }
    } catch {
      return 'N/A'
    }
  }

  getEta = async (trip) => {
    if (trip.onsiteEventTime == null && trip.lastKnownPositionLat !== 0 && trip.lastKnownPositionLon !== 0 && trip.pickupLat !== 0 && trip.pickupLon !== 0) {
      const actualCoordinates = { lat: trip.lastKnownPositionLat, lon: trip.lastKnownPositionLon };
      const destCoordinates = { lat: trip.pickupLat, lon: trip.pickupLon };
      return this.getDistanceMatrix(actualCoordinates, destCoordinates);
    } else {
      return 0;
    }
  }

  componentDidUpdate() {
    if (this.props.selectedTrip !== this.state.selectedTrip) {
      this.setState({
        selectedTrip: this.props.selectedTrip,
        isMapEnable: false,
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  formatWillCall(willcall) {
    var result = 'None';
    if (willcall) {
      result = willcall;
    }
    return result;
  }

  render() {
    return (
      <div style={this.calculateTabPanelHeight()}>
        {this.props.isLoadingDetails && <LoadingSpinner type={'panel'} />}
        <div style={{ height: '60%' }}>
          <div style={mapHeaderContainer}>
            <span style={tripsIcons}><span style={fontWeightBold}>
              Trip:
            </span> {formatValue(this.state.selectedTrip?.tripNumber)}
            </span>
            <span style={tripsIcons}>
              {this.serviceLevelSwitch(this.state.selectedTrip?.serviceLevelName)}
              {this.state.selectedTrip?.serviceLevelName}</span>
            <span style={tripsIcons}>{this.state.selectedTrip?.tripStatus}</span>
          </div>
          {this.state.isMapEnable ?
            <div style={mapContainerSetting}>
              <MapContainer id='algo'
                latitudePickup={this.state.selectedTrip?.pickupLat}
                longitudePickup={this.state.selectedTrip?.pickupLon}
                latitudeDriver={this.state.selectedTrip?.lastKnownPositionLat}
                longitudeDriver={this.state.selectedTrip?.lastKnownPositionLon}
                tripNumber={this.state.selectedTrip?.tripNumber} />
            </div> :
            <div style={buttonMap}>
              <Button icon="map" text="Show Map" onClick={this.handleShowMapClick} disabled={this.state.selectedTrip === null} />
            </div>
          }

          <div style={mapFooterContainer}>
            <span style={spanSetting}>
              <strong>Due:</strong>
              {this.state.selectedTrip !== null ? moment.tz(this.state.selectedTrip?.dueDateTime,
                this.state.selectedTrip?.pickupTimeZone).format(`${SHORT_DATE_TIME_FORMAT_24} z`) : ''}
            </span>
            <span style={spanSetting}><strong>ETA:</strong> {this.state.selectedTrip?.eta}</span>
            <span style={asOfSpan}>
              <strong>As Of:</strong>
              {this.state.selectedTrip !== null ? moment().format(`${SHORT_TIME_FORMAT_24}`) : ''}
            </span>
          </div>
          <div style={willCallContainer}>
            <div>
              <span><strong>Willcall:&nbsp;</strong>{this.formatWillCall(this.state.selectedTrip?.willCallStatus)}</span>
            </div>
            <div style={inlineFlex}>
              <span><strong>ServiceMethod:&nbsp;</strong>{formatValue(this.state.selectedTrip?.serviceMethod)}</span>
            </div>
          </div>
          <Divider style={{ height: '3%', margin: '0px', borderRight: '0px' }} />
        </div>
        <Tabs animate={true} id="trip-tabs" renderActiveTabPanelOnly={true}>
          <Tab id="details" title="Details" panel={<TripDetailTabPanel
            handleLoading={this.props.handleKeySpinner}
            isLoading={this.props.isLoadingKeyEvents}
            trip={this.state.selectedTrip}
            openTripContainer={this.state.openTripContainer}
            height={this.state.height} />} style={tabSpanMargin} />
          <Tab id="notes" title="Notes" panel={<TripNotesPanel height={this.state.height} trip={this.state.selectedTrip} />} />
          {/* <Tab id="history" title="Event Log" panel={<TripHistoryTabPanel />} panelClassName="ember-panel" /> */}
          <Tabs.Expander />
        </Tabs>
      </div>
    )
  }
}
